import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { City, form_control } from "projects/sepidz-web-framework/src/lib/models";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { GridFilter, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
@Component({
  selector: "received-from-rahkaran-form",
  templateUrl: "./received-from-rahkaran-form.component.html",
  styleUrls: ["./received-from-rahkaran-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceivedFromRahkaranFormComponent extends BaseFormComponent<City> {
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private splashFormService: SplashFormService) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.label = "دریافت اسناد از راهکاران";
    super.ngOnInit();
  }
  setColumnAttribute() {
    this.columns = [];
    this.columns.push(<form_control>{
      label: "تاریخ سند",
      controlType: FormControlTypes.datePicker,
      modelName: "VoucherDate",
      disabled: false,
      name: "VoucherDate",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
    });
    this.columns.push(<form_control>{
      label: "نوع سند",
      controlType: FormControlTypes.dropdown,
      modelName: "InvVoucherKindId",
      disabled: false,
      name: "InvVoucherKindId",
      order: 0,
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: true,
      apiName: "InvVoucherKind/ReadLookUpReceivedFromRahkaran",
      valueMember: "Id",
      displayMember: "Title",
    });
    this.orignalColumns = this.columns;
  }
  addControl() {
    this.setValue("VoucherDate", new Date());
    this.cd.markForCheck();
  }
  public async save() {
    let gridFilter: GridFilter[] = [];
    gridFilter.push({
      Type: "F",
      Filed: "VoucherDate",
      Value: this.formGroup.get("VoucherDate").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });
    gridFilter.push({
      Type: "F",
      Filed: "InvVoucherKindId",
      Value: this.formGroup.get("InvVoucherKindId").value,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    });

    this.httpCommonService
      .create(this.apiName, gridFilter)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (x) => {
          this.splashFormService.closeLoading();
          this.tabsservice.tabItemonRefreshData.next(this.apiName);
          this.sts.showDialog("دریافت از راهکاران با موفقیت صادر شد.", "");
          this.cancel();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در دریافت از راهکاران${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
}
